export const getCurrentTimeInfo = () => {
  const now = new Date()

  const date = now.toLocaleDateString('en-US', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  })
  const time = now.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  })
  const timestamp = now.getTime()
  const zones = now?.toString().match(/\((.+)\)/)
  const timezone = zones && zones.length && zones[1] // Extract timezone from Date object
  const year = now.getFullYear()

  return {
    date,
    time,
    timestamp,
    timezone,
    year,
  }
}

export function formatTimestamp(timestamp: number): string {
  const date = new Date(timestamp)
  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  }
  return date.toLocaleString(undefined, options)
}

export const getFormattedTime = (timeStamp: number) => {
  return new Date(timeStamp).toLocaleTimeString('en-IN', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  })
}

export const getFormattedDate = (timeStamp: number) => {
  return new Date(timeStamp).toLocaleDateString('en-IN', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  })
}

export const getDayTimestamps = (
  date = new Date()
): { morning: number; night: number } => {
  // Create a new date object for the given date
  const year = date.getFullYear()
  const month = date.getMonth() // Month is 0-indexed
  const day = date.getDate()
  // Set morning timestamp (00:00:00)
  const morning = new Date(year, month, day, 0, 0, 0).getTime()
  // Set night timestamp (23:59:59)
  const night = new Date(year, month, day, 23, 59, 59).getTime()
  return {
    morning,
    night,
  }
}
